import { styled } from 'styled-components';

export const Container = styled.li`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 3px 20px;

  .beta-feature-label {
    pointer-events: none;
  }

  .btn {
    margin: 0 !important;
  }
`;
